export const IS_MEASURING = "IS_MEASURING";
export const ADD_POINT = "ADD_POINT";